import React, { useEffect, useState } from "react";
import styles from "./ResetPassword.module.css";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";
import AssetsPack from "../../../util/AssetsPack";
import { useTranslation } from "react-i18next";
import InputBox, {
  InputBoxRoundedCornors,
  InputBoxState,
} from "../../../components/InputBox";
import { JokerButton, ButtonType } from "material-ui-jokerpro";
import StylePack from "../../../util/StylePack.js";
import { verifyAccountForResetPassword } from "../../../store/forget-password-slice";
import { useAppDispatch } from "../../../store/hooks";
import MainTemplate from "../../Templates/MainTemplate";
import TwoColLayout from "../../Templates/TwoColLayout";
import TitleText, { TitleTextSize } from "../../../components/TitleText";
import Paragraph from "../../../components/Paragraph";
import ImageComponent from "../../../components/ImageComponent";

const ResetPassword = () => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const [inputValue, setInputValue] = useState("");
  const [errorValue, setErrorValue] = useState<string | undefined>(undefined);
  const [emailState, setEmailState] = useState<InputBoxState | undefined>(
    InputBoxState.default
  );
  const dispatch = useAppDispatch();

  const handleContinue = async (e: any) => {
    e.preventDefault();
    if (emailState != InputBoxState.error) {
      try {
        await dispatch(verifyAccountForResetPassword(inputValue));
        navigate("/check_inbox");
      } catch (error: any) {
        setErrorValue(error.message);
      }
    }
  };

  const handleCancel = (e: any) => {
    e.preventDefault();
    navigate(-1);
  };

  const isValidEmail = async (value: string): Promise<boolean> => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      setErrorValue("Invalid Email.");
      return false;
    }
    return true;
  };

  const getInputState = async (value: any) => {
    setErrorValue(undefined);
    if (value.length === 0) {
      return InputBoxState.default;
    }

    if (await isValidEmail(value)) {
      return InputBoxState.default;
    } else {
      return InputBoxState.error;
    }
  };

  useEffect(() => {
    const validateEmail = async () => {
      const state = await getInputState(inputValue);
      setEmailState(state);
    };
    validateEmail();
  }, [inputValue]);

  const rightContent = (
    <div className={styles["info-section"]}>
      <div className={styles["icon"]}>
        <ImageComponent src={AssetsPack.icons.ICON_BELL.default} />
      </div>
      <Paragraph>{t("reset_password_page.info")}</Paragraph>
    </div>
  );

  const leftContent = (
    <div className={styles["form-section"]}>
      <TitleText size={TitleTextSize.heading2}>
        {t("reset_password_page.title")}
      </TitleText>
      <Paragraph>{t("reset_password_page.description")}</Paragraph>
      <InputBox
        state={emailState}
        roundedCornors={InputBoxRoundedCornors.all}
        type="text"
        placeholder={t("reset_password_page.input")}
        value={inputValue}
        onChange={(e: any) => setInputValue(e.target.value)}
        errorMessage={errorValue}
      />

      <div className={styles["button-group"]}>
        <JokerButton
          text={t("reset_password_page.cancel")}
          onClick={handleCancel}
          type={ButtonType.Text}
          icon={AssetsPack.icons.ICON_CLOSE.default}
          equal
        />
        <JokerButton
          text={t("reset_password_page.continue")}
          onClick={handleContinue}
          disabled={emailState === InputBoxState.error || inputValue == ""}
          type={ButtonType.CTA}
          icon={AssetsPack.icons.ICON_GO.default}
          animated
          equal
        />
      </div>
    </div>
  );

  const body = (
    <TwoColLayout rightContent={rightContent} leftContent={leftContent} />
  );

  return (
    <MainTemplate
      body={body}
      footer={<Footer />}
      backgroundStyle={StylePack.BACKGROUND_LOGIN_STYLE}
      hasOverlayFooter
    />
  );
};

export default ResetPassword;
